import React from 'react';
import LogoImg from '../logo.svg';

// Constants
const LOGO_ALT_TEXT = 'Jinesh P.V';
const LOGO_CLASS_NAME = 'logo';
const LOGO_HREF = '/';

// Component
const Logo = () => {
    return (
        <a href={LOGO_HREF} className={LOGO_CLASS_NAME} aria-label="Homepage">
            <img
                src={LogoImg}
                alt={LOGO_ALT_TEXT}
                width={120}
                height={40}
                loading="lazy"
            />
        </a>
    );
};

// Export memoized version for performance optimization
export default React.memo(Logo);
